import React from 'react';
import PropTypes from "prop-types";
import css from 'scss';

const CheckPoint = (props) => {
    const checked = props.checked || props.showTutorial;

    return (
        <g className={`answer_point ${props.answered ? 'answer__answered' : ''}`} transform={`translate(${props.x}, ${props.y})`} onClick={props.click}>
            <circle className="answer_point__border" fill="#000" stroke={props.highlight || props.showTutorial ? css['$color-yellow'] : css['$color-white']} strokeWidth="2" cx="24" cy="24" r="24"
                    onMouseOut={props.out} onMouseOver={props.over} />
            {checked &&
                <circle className="answer_point__inner" fill={css['$color-yellow']} cx="24" cy="24" r="14"/>
            }

            {(props.align === 'left') ?
                <g transform="translate(0, -286)">
                    <path className="line" fill={props.selected ? css['$color-yellow'] : css['$color-white']} d="M170.8,136.7c-63.3,26.8-113.7,77.2-140.6,140.6c-1.5,3.5-2.9,7.1-4.2,10.6h0.6
        c1.3-3.5,2.7-7,4.1-10.4c26.8-63.2,77.1-113.5,140.3-140.3c32.5-13.7,67-20.7,102.7-20.7v-0.5C238,115.9,203.4,122.9,170.8,136.7z"
                    />
                </g>
                :
                <g transform="translate(-950, -284)">
                    <path className="line" fill={props.selected ? css['$color-yellow'] : css['$color-white']} d="M823.1,489.6C888.7,462,940.8,410,968.6,344.7c1.5-3.6,3-7.3,4.4-11h-0.6
		c-1.4,3.6-2.8,7.2-4.3,10.8c-27.7,65.2-79.8,117-145.2,144.6c-33.6,14.2-69.4,21.3-106.2,21.3v0.5
		C753.6,511,789.4,503.8,823.1,489.6z"/>
                </g>
            }
        </g>
    );
};

export default CheckPoint;

CheckPoint.defaultProps = {
    x: 0,
    y: 0,
    click: () => {},
    out: () => {},
    over: () => {},
    checked: false,
    highlight: false,
    selected: false,
    align: 'left',
};

CheckPoint.propTypes = {
    x: PropTypes.number,
    y: PropTypes.number,
    click: PropTypes.func,
    out: PropTypes.func,
    over: PropTypes.func,
    checked: PropTypes.bool,
    highlight: PropTypes.bool,
    selected: PropTypes.bool,
    align: PropTypes.string,
    showTutorial: PropTypes.bool
};


// WEBPACK FOOTER //
// ./sources/js/components/Question/graph/CheckPoint.js